module.exports = __webpack_public_path__ + "img/placeholder.fcb3e0c1.jpg";